import { namespaceConfigurationUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import {
  CreateRoutingPathPayload,
  MachineGroupRoutingPath,
} from "@src/types/namespace-configuration";
import axios, { isAxiosError } from "axios";
import { buildAxiosAuthenticationHeaders } from "@src/cloud-connect/api/util/build-axios-authentication-headers";

export const postCreateRoutingPath = async (
  namespace: string,
  payload: CreateRoutingPathPayload,
): Promise<MachineGroupRoutingPath> => {
  const url = namespaceConfigurationUrlEnvVar();
  const headers = buildAxiosAuthenticationHeaders();

  try {
    const response = await axios.post<MachineGroupRoutingPath>(
      `${url}/api/v1/ns/${namespace}/routing-paths`,
      payload,
      { headers },
    );

    return response.data;
  } catch (err) {
    if (isAxiosError(err)) {
      console.error("Axios error:", err);
      throw new Error(
        err.response?.data?.detail ||
          err.response?.data?.message ||
          "Failed to create routing path. Please try again later.",
      );
    }

    throw new Error(
      "An unexpected error occurred while creating routing path.",
    );
  }
};
